// Centralized app feature flags — toggle behavior without hunting through components.

export const featureFlags = {
  // Controls visibility and flow for free trial signup across website
  FREE_TRIAL_ENABLED: false,

  // Controls visibility of Landing Page Settings in the admin panel
  LANDING_PAGE_SETTINGS_ENABLED: true,

  // Pending appointment confirmation: SMS reply CONFIRM only (no confirmation links)
  PENDING_CONFIRMATION_REPLY_ONLY: true,
};

export function isPendingConfirmationReplyOnlyEnabled() {
  return featureFlags.PENDING_CONFIRMATION_REPLY_ONLY;
}

export default featureFlags;
